import React from 'react'
import apiInstance from '../../utils/axios'
import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'

function ForgotPassword() {
  const [email, setEmail] = useState("") 
  const [isLoading, setIsLoading] = useState(false) 

  const navigate = useNavigate()

  const handleSubmit= async() => {
    setIsLoading(true)
    try {
        await apiInstance.get(`user/password-reset/${email}/`).then((res) => {
            alert("Se ha enviado un correo electrónico a tu dirección.")
            setIsLoading(false)
        })
    } catch (error) {
        alert("El correo electrónico no existe")
        setIsLoading(false)

    }

  }

  return (
    <section>
    <main className="" style={{ marginBottom: 100, marginTop: 50 }}>
        <div className="container">
            {/* Section: Login form */}
            <section className="">
                <div className="row d-flex justify-content-center">
                    <div className="col-xl-5 col-md-8">
                        <div className="card rounded-5">
                            <div className="card-body p-4">
                                <h3 className="text-center">Olvidé mi Contraseña</h3>
                                <br />

                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="pills-login"
                                        role="tabpanel"
                                        aria-labelledby="tab-login"
                                    >
                                        <div>
                                            {/* Email input */}
                                            <div className="form-outline mb-4">
                                                <label className="form-label" htmlFor="Full Name">
                                                    Dirección de Correo Electrónico
                                                </label>
                                                <input
                                                    type="text"
                                                    id="email"
                                                    name="email"
                                                    className="form-control"
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </div>

                                            {isLoading === true
                                            ?                                             
                                            <div className="text-center">
                                              <button disabled type="button" className='btn btn-primary w-100'>Procesando... <i className="fas fa-spinner fa-spin" /></button>
                                            </div>

                                            :
                                            <div className="text-center">
                                                <button onClick={handleSubmit} type='button' className='btn btn-primary w-100'>Restablecer Contraseña <i className='fas fa-paper-plane'></i></button>
                                            </div>

                                            }



                                            <div>
                                              <p className="text-center">
                                                  ¿Aún no tienes una cuenta?
                                                  <Link to='/register'>
                                                      Registrarse
                                                  </Link>
                                              </p>
                                            </div>

                                            <div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </main>
</section>
  )
}

export default ForgotPassword